import { render } from "./SecurityEventModal.vue?vue&type=template&id=1675a622&scoped=true"
import script from "./SecurityEventModal.vue?vue&type=script&lang=js"
export * from "./SecurityEventModal.vue?vue&type=script&lang=js"

import "./SecurityEventModal.vue?vue&type=style&index=0&id=1675a622&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1675a622"]])

export default __exports__